export default "# Near101\n\nA summary of Near101\n";